import { money } from "../lib/api";
import { Card, Tag } from "./bits";

export function OpenPositions({ risk }) {
  const rows = risk?.open_positions || [];
  if (!rows.length) return null;
  const asOf = rows[0]?.as_of;
  return (
    <Card className="mt-4" title="Open positions (broker-synced)" sub={`Floating P&L ${money(risk.floating_pnl)} is included in today's risk budget · as of ${asOf ? new Date(asOf).toLocaleTimeString() : "last sync"} · refreshed with each broker sync`} testId="open-positions-card">
      <div className="tbl-wrap"><table className="tbl" data-testid="open-positions-table">
        <thead><tr><th>Symbol</th><th>Class</th><th>Side</th><th>Volume</th><th>Open</th><th>Now</th><th>Stop</th><th>Floating</th></tr></thead>
        <tbody>{rows.map((p) => (
          <tr key={p.position_id} data-testid={`open-position-${p.position_id}`}>
            <td><b>{p.symbol}</b></td><td><Tag kind="info">{p.asset_class}</Tag></td><td>{p.direction}</td><td className="mono">{p.volume}</td><td className="mono">{p.open_price}</td><td className="mono">{p.current_price}</td>
            <td className="mono">{p.stop_loss || <span className="sub" title="No stop loss set">none</span>}</td>
            <td className="mono" style={{ color: Number(p.profit) < 0 ? "#f87171" : "var(--gold)" }}>{money(p.profit)}</td>
          </tr>))}</tbody>
      </table></div>
    </Card>
  );
}
